// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rmoxuodrbhesecbxiwtz.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJtb3h1b2RyYmhlc2VjYnhpd3R6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk5Njg4NzgsImV4cCI6MjA4NTU0NDg3OH0.YGw29aX2_7s3KWIs0vI8_tSAJAos7Sxnp0tfS7bLOjc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'sb-mtiq-auth',
  },
});
